/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    UpgradeDividerMessage: {
        id: 'cep.components.sgRenewalUpgradeAccordion.UpgradeDividerMessage',
        defaultMessage: 'or upgrade to'
    },
    PrivateMotorUpgradeToFixedPrice: {
        id: 'cep.components.sgRenewalUpgradeAccordion.PrivateMotorUpgradeToFixedPrice',
        defaultMessage: 'Upgrade to Saga Plus and enjoy a 3-year fixed price'
    },
    PrivateHomeUpgradeToFixedPrice: {
        id: 'cep.components.sgRenewalUpgradeAccordion.PrivateHomeUpgradeToFixedPrice',
        defaultMessage: 'Upgrade to Saga Plus and benefit from a 3-year fixed price'
    },
    PrivateTravelUpgradeToFixedPrice: {
        id: 'cep.components.sgRenewalUpgradeAccordion.PrivateTravelUpgradeToFixedPrice',
        defaultMessage: 'Upgrade to Saga Plus for even greater benefits'
    },
    PrivateMotorFixedPriceInfo1: {
        id: 'cep.components.sgRenewalUpgradeAccordion.PrivateMotorFixedPriceInfo1',
        defaultMessage: 'Your car insurance premium stays the same if nothing changes, as we fix the price for your next two renewals '
    },
    PrivateMotorFixedPriceInfo2: {
        id: 'cep.components.sgRenewalUpgradeAccordion.PrivateMotorFixedPriceInfo2',
        defaultMessage: '. The only thing that\'s fixed is your price, you\'re free to cancel at any time with no cancellation fee to pay.'
    },
    PrivateHomeFixedPriceInfo1: {
        id: 'cep.components.sgRenewalUpgradeAccordion.PrivateHomeFixedPriceInfo1',
        defaultMessage: 'Your home insurance premium stays the same if nothing changes, as we fix the price for your next two renewals '
    },
    PrivateHomeFixedPriceInfo2: {
        id: 'cep.components.sgRenewalUpgradeAccordion.PrivateHomeFixedPriceInfo2',
        defaultMessage: '. The only thing that\'s fixed is your price, you\'re free to cancel at any time with no cancellation fee to pay.'
    },
    PrivateTravelFixedPriceInfo1: {
        id: 'cep.components.sgRenewalUpgradeAccordion.PrivateTravelFixedPriceInfo1',
        defaultMessage: 'Saga Plus offers higher cover levels for medical expenses, cancellation and lost or damaged baggage. If your flight is delayed by more than an hour and you\'ve registered with us at least 6 hours before takeoff, we\'ll pop you in an airport lounge to wait in comfort.'
    },
    TCApply: {
        id: 'cep.components.sgRenewalUpgradeAccordion.TCApply',
        defaultMessage: '(T&C\'s apply)'
    },
    BackToOriginalRenewal: {
        id: 'cep.components.sgRenewalUpgradeAccordion.BackToOriginalRenewal',
        defaultMessage: 'Back to original renewal'
    },
    ReadMore: {
        id: 'cep.components.sgRenewalUpgradeAccordion.ReadMore',
        defaultMessage: 'Read more'
    },
    CompareCoverDetails: {
        id: 'cep.components.sgRenewalUpgradeAccordion.CompareCoverDetails',
        defaultMessage: 'Compare cover details'
    },
    ViewOurTerms: {
        id: 'cep.components.sgRenewalUpgradeAccordion.ViewOurTerms',
        defaultMessage: 'View our terms and conditions and read more about our '
    },
    FixedPriceCover: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FixedPriceCover',
        defaultMessage: 'fixed price cover'
    },
    ReadLess: {
        id: 'cep.components.sgRenewalUpgradeAccordion.ReadLess',
        defaultMessage: 'Read less'
    },
    CheckMyPrice: {
        id: 'cep.components.sgRenewalUpgradeAccordion.CheckMyPrice',
        defaultMessage: 'Check my price'
    },
    UpgradeHeading: {
        id: 'cep.components.sgRenewalUpgradeAccordion.UpgradeHeading',
        defaultMessage: 'Your 3-year fixed price renewal for our highest cover level Saga Plus'
    },
    Pay: {
        id: 'cep.components.sgRenewalUpgradeAccordion.Pay',
        defaultMessage: 'Pay '
    },
    NextThreeYears: {
        id: 'cep.components.sgRenewalUpgradeAccordion.NextThreeYears',
        defaultMessage: ' for the next 3 years'
    },
    BackToOriginalOfferLabel: {
        id: 'cep.components.sgRenewalUpgradeAccordion.BackToOriginalOfferLabel',
        defaultMessage: 'Back to original renewal'
    },
    CompareButtonLabel: {
        id: 'cep.components.sgRenewalUpgradeAccordion.CompareButtonLabel',
        defaultMessage: 'Compare cover details'
    },
    ExtraFeatures: {
        id: 'cep.components.sgRenewalUpgradeAccordion.ExtraFeatures',
        defaultMessage: 'With Saga Plus you get extra features included as standard:'
    },
    FeatureThreeYearFixed: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FeatureThreeYearFixed',
        defaultMessage: '3-year fixed price'
    },
    FeatureOnePrivateHome: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FeatureOnePrivateHome',
        defaultMessage: 'Accidental damage cover'
    },
    FeatureOnePrivateMotor: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FeatureOnePrivateMotor',
        defaultMessage: 'Legal protection'
    },
    FeatureTwoPrivateHome: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FeatureTwoPrivateHome',
        defaultMessage: 'Matching sets cover'
    },
    FeatureTwoPrivateMotor: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FeatureTwoPrivateMotor',
        defaultMessage: 'Accident healthcare'
    },
    FeatureThreePrivateHome: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FeatureThreePrivateHome',
        defaultMessage: 'Alternative accommodation'
    },
    FeatureThreePrivateMotor: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FeatureThreePrivateMotor',
        defaultMessage: 'Onward taxi travel'
    },
    FeatureClaimsPromise: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FeatureClaimsPromise',
        defaultMessage: 'Claims promise'
    },
    FeatureKeyProtection: {
        id: 'cep.components.sgRenewalUpgradeAccordion.FeatureKeyProtection',
        defaultMessage: 'Key protection'
    }
});
